import { Injectable } from '@angular/core';

/**
 * InternalStateType interface
 */
export interface InternalStateType {
    [key: string]: any;
}

/**
 * Application state service
 */
@Injectable()
export class AppState {

    /**
     * local state InternalStateType
     */
    public _state: InternalStateType = {};

    /**
     * Already return a clone of the current state.
     */
    public get state() {
        return this._state = this._clone(this._state);
    }

    /**
     * Never allow mutation
     */
    public set state(value) {
        throw new Error('do not mutate the `.state` directly');
    }

    /**
     * get property from state
     * @param prop
     * @returns {any} property of state
     */
    public get(prop?: any) {
        /**
         * Use our state getter for the clone.
         */
        const state = this.state;
        return state.hasOwnProperty(prop) ? state[prop] : state;
    }

    /**
     * set property to state
     * @param {string} prop
     * @param value
     * @returns {any} property of state
     */
    public set(prop: string, value: any) {
        /**
         * Internally mutate our state.
         */
        return this._state[prop] = value;
    }

    /**
     * clone object
     * @param {InternalStateType} object
     * @returns {any}
     * @private
     */
    private _clone(object: InternalStateType) {
        /**
         * Simple object clone.
         */
        return JSON.parse(JSON.stringify(object));
    }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts